import api from "../axios";

export async function uploadDesignFile(file, doc_dns, extra = {}) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("doc_dns", doc_dns);

  // optional params
  if (extra.index) formData.append("index", extra.index);
  if (extra.project) formData.append("project", extra.project);

  // ✅ 중요: axios가 Content-Type을 자동 지정하도록 header를 비워둬야 함
  const res = await api.post(`/design/file/upload/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return res.data;
}

// 디자인 파일 삭제
export const deleteDesignFile = (fileId) => {
  return api.delete(`/design/file/${fileId}/delete/`);
};


/**

 * ✅ DCN 승인 후, 설계도서 라이브러리에 반영 요청
 * (DesignFile을 기반으로 라이브러리에 복제 및 이력 저장)
 * @param {string} projectId - 프로젝트 ID (예: PJT001)
 * @param {string} docDns - DCN 문서 DNS
 * @returns {Promise<Object>} 반영 결과
 */
export const applyDesignFilesFromDCN = async (projectId, dns) => {
  console.log("📡 [API 요청] applyDesignFilesFromDCN:", { projectId, dns });

  try {
    const res = await api.post(
      `/design/library/apply/`,
      { project: projectId, doc_dns: dns }, // body JSON 전달
      { headers: { "Content-Type": "application/json" } }
    );
    console.log("🎉 성공 응답:", res.data);
    return res.data;
  } catch (err) {
    console.error("❌ DCN 라이브러리 반영 실패:", err.response?.data || err);
    throw err;
  }
};
